import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import {
    EventRowTitle,
    MobileParticipant,
    Score,
} from 'src/domains/sportsbook/webview/components/events/row/Participant.style';
import { EventRowItemLogo } from 'src/domains/sportsbook/webview/components/eventsList/eventRow6Pack/Participant6Pack.style';
import { EventRow6PackState } from 'src/domains/sportsbook/webview/components/eventsList/eventRow6Pack/EventRow6Pack.state';
import { observer } from 'src/utils/mobx-react';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { isOutrightEventItem } from 'src/domains/sportsbook/utils/isOutrightEvent';

interface ParticipantPropsType {
    smallEvent: EventListGroupEventItemType;
    state?: Pick<EventRow6PackState, 'getParticipantLogo'> | null;
}

export const Participant = observer('Participant', (props: ParticipantPropsType) => {
    const { smallEvent, state = null } = props;
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const {
        componentVariants: { eventRowVariant },
    } = ConfigComponents.get(common).unifiedComponentConfig;

    const eventModel = smallEvent.id2.getEventModel();

    const homeParticipant = eventModel?.homeParticipant ?? null;
    const awayParticipant = eventModel?.awayParticipant ?? null;

    let homePart = homeParticipant;
    let awayPart = awayParticipant;

    const sport = eventModel?.sport;

    const isAmericanFootball = sport === 'americanfootball';
    const isBasketball = sport === 'basketball';
    const isBaseball = sport === 'baseball';
    const isTennis = sport === 'tennis';

    if (eventModel !== null && (isAmericanFootball || isBasketball || isBaseball || isTennis)) {
        const splittedEventName = smallEvent.name.split(/\s+vs?\s+/);

        homePart = splittedEventName[0] ?? homeParticipant;
        awayPart = splittedEventName[1] ?? awayParticipant;
    }

    if (
        isOutrightEventItem(smallEvent) ||
        eventModel === null ||
        (breakpointsState.tablet.isBiggerOrEq === true &&
            eventRowVariant !== DefaultComponentVariantType.SECONDARY &&
            eventRowVariant !== DefaultComponentVariantType.TERTIARY) ||
        (homePart === null && awayPart === null)
    ) {
        return (
            <EventRowTitle
                variant={eventRowVariant}
                data-test='participant'
            >
                {smallEvent.name}
            </EventRowTitle>
        );
    }

    const { scoreHome, scoreAway, timeSettingsStarted } = eventModel;

    const renderScore = (score: number | null) =>
        eventRowVariant == DefaultComponentVariantType.TERTIARY && timeSettingsStarted && score !== null ? (
            <Score>{score}</Score>
        ) : null;

    const participants = [
        [homePart, scoreHome],
        [awayPart, scoreAway],
    ] as const;

    return (
        <>
            {participants.map(([participant, score], index) => {
                const logo = state?.getParticipantLogo(participant) ?? null;

                return (
                    <MobileParticipant
                        key={participant ?? index}
                        variant={eventRowVariant}
                    >
                        {logo !== null ? (
                            <EventRowItemLogo
                                alt={participant ?? ''}
                                decoding='async'
                                loading='lazy'
                                variant={eventRowVariant}
                                src={logo}
                            />
                        ) : null}

                        {participant}
                        {renderScore(score)}
                    </MobileParticipant>
                );
            })}
        </>
    );
});
